import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Role } from './../../../model/role';
import { Permission } from './../../../model/permission';
import { RolesService } from '../../../service/component_dependent/users/roles.service';
import { PermissionService } from '../../../service/component_dependent/permission.service';
import { RolePermissions } from '../../../model/role-permissions';
import { NotifierService } from '../../../service/component_dependent/notifier.service';
import { PermissionsListComponent } from '../../shared/permissions-list/permissions-list.component';
import { Router } from '@angular/router';
import { JsonManager } from '../../../service/managers/json-manager';

@Component({
  selector: 'app-create-roles',
  templateUrl: './create-roles.component.html',
  styleUrls: ['./create-roles.component.scss']
})
export class CreateRolesComponent implements OnInit {

  public role: Role = {
    id: null,
    name: null,
    display_name: null,
    description: null,
  };

  public roles = [];
  public permissionsSelectedID = [];

  @ViewChild(PermissionsListComponent) permListComp: PermissionsListComponent;

  constructor(private roleService: RolesService, private permissionService: PermissionService,
    private notifierService: NotifierService, private router: Router) {

  }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  public readonly TABLE_HEADERS = [
    'Name', 'Display Name', 'Description'
  ];

  public getRoles(maxItemPerPage, page, keyword) {
    this.roleService.getRoles(maxItemPerPage, page, keyword).subscribe(
      data => {
        this.reassignVariablesRoles(data);
      }
    )
  }

  private reassignVariablesRoles(data) {
    this.roles = data.data;
  }


  public saveAndInsert() {
    this.onSubmit("SAI");
  }

  public saveAndExit() {
    this.onSubmit("SAE");
  }

  public onSubmit(mode: string) {

    let rolePermissions = new RolePermissions();

    this.roleService.storeRole(this.role).subscribe(
      (data: any) => {
        rolePermissions.roleID = data.id;
        rolePermissions.permissionsID = this.permissionsSelectedID;
        this.roleService.storeRolePermissions(rolePermissions).subscribe(
          (dataB: any) => {
            if (mode == "SAE") {
              this.exit();
            } else if (mode == "SAI") {
              this.clearRegistrationForm();
            }

            this.notifierService.showSuccess(data.message);
          },
          (error: any) => {
            this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
          },
        )
      },
      (error: any) => {
        this.notifierService.showError(JsonManager.getBreakLineSeparatedErrorMessages(error.error.message));
      },
    )
  }

  private clearRegistrationForm() {
    this.permListComp.clearAll();
    this.permissionsSelectedID = [];
    this.role = new Role();
    document.forms['roleForm'].reset();
  }

  private exit() {
    this.router.navigateByUrl("/joytogive/roles");
  }

  private clear(){
    this.permListComp.clearAll();
  }

}
